<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-row v-if="loading">
          <b-col
            cols="12"
          >
            <loading-card />
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col
            cols="12"
            md="12"
          >
            <default-card
              title="Satışlar + Bağlantılar"
              :value="overviews.sales"
              icon="CheckCircleIcon"
              color="primary"
              to-page="/sales/sales"
            />
          </b-col>
          <b-col cols="12">
            <mixed-charts
              :categories-data="overviews.charts.categories"
              :series-data="overviews.charts.series"
              :title-text="overviews.charts.chartTitle"
              :yaxis-data="overviews.charts.yaxis"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <default-card
              title="Bağlantılar"
              :value="overviews.connections"
              icon="LinkIcon"
              color="secondary"
              to-page="/sales/connections"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <default-card
              title="Satış Hedefi"
              :value="overviews.goals"
              icon="ArrowUpRightIcon"
              color="info"
              to-page="/sales/stocks"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <default-card
              title="Stoklar"
              :value="overviews.stocks"
              icon="CodesandboxIcon"
              color="info"
              to-page="/sales/stocks"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <default-card
              title="Takaslar"
              :value="overviews.swaps"
              icon="RefreshCcwIcon"
              color="warning"
              to-page="/sales/swaps"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <default-card
              title="Görüşmeler"
              :value="overviews.interviews"
              icon="MessageSquareIcon"
              color="danger"
              to-page="/sales/insurances"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <default-card
              title="Müşteriler"
              :value="overviews.customers"
              icon="UserPlusIcon"
              color="success"
              to-page="/sales/interviews"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import DefaultCard from '@/layouts/components/ReportCards/DefaultCard.vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import MixedCharts from '@/layouts/components/ReportCharts/MixedCharts.vue'

export default {
  name: 'Sales',
  components: {
    LoadingCard,
    BRow,
    BCol,
    DefaultCard,
    MixedCharts,
  },
  computed: {
    loading() {
      return this.$store.getters['saleOverviews/loading']
    },
    overviews() {
      return this.$store.getters['saleOverviews/overviews']
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('saleOverviews/getOverviews')
    },
    getRandomValue(max) {
      return Math.floor(Math.random() * max)
    },
  },
}
</script>
